import React, {useEffect, useState} from "react";
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../../components/Portlet";
import {connect} from "react-redux";
import {
  DeleteItem,
  GetItem,
  UpdateItem
} from "../../../../redux/actions/base";
import {AirBookingListRoute} from "../../../routesConstants";
import {useParams} from "react-router-dom";
import BlockUi from "@availity/block-ui";
import {Row, Col} from "react-bootstrap";
import moment from "moment";
import AirBookingForm from "../components/airBookingForm";
import {Helmet} from "react-helmet";

const AirBookingEditPage = props => {
  const [airBooking, setAirBooking] = useState(null);
  const [parseText, setParseText] = useState("");
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const {id} = useParams();

  const getItem = () =>{
    setLoader(true);
    props.GetItem("/api/air/airBooking", id, res => {
      console.log("res", res);
      setAirBooking(res.data.airBooking);
      setParseText(res.data.parseText || "");
      setLoader(false);
    });
  }
  useEffect(() => {
    if (airBooking === null) {
      getItem()
    }
  }, [airBooking, id, props]);
  const callback = (values, cb) => {
    setLoading(true)
    props.UpdateItem(
      "/api/air/airBooking/" + id,
      {airBooking: values,importOneS:values.importOneS},
      () => {
        cb();
        setLoading(false)
      },
      AirBookingListRoute
    );
  };
  return (
    <>
      <Helmet>
        <title>{`Бронь ${airBooking?.bookingNumber}` || 'БСО'}</title>
      </Helmet>
      <BlockUi blocking={loader}>
        {airBooking ? (
          <AirBookingForm onSubmit={callback}
                          data={airBooking}
                          savedParseText={parseText}
                          reload={()=>getItem()}
                          loading={loading}
                          edit/>
        ) : null}
      </BlockUi>
    </>
  );
};

export default connect(null, {GetItem, UpdateItem})(AirBookingEditPage);
